import { Box, Button, Container, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import globalContext from '../context/context'
import axios from "axios";
import { useTranslation } from "react-i18next";
import TransferDetails from "./ShowMyBookingElements/TransferDetails";
import LoungeDetails from "./ShowMyBookingElements/LoungeDetails";
import ParkingDetails from "./ShowMyBookingElements/ParkingDetails";

const ticketStyle = {
    display: 'inline-block',
    padding: '5px',
    border: '1px solid #333',
    textDecoration: 'none',
    color: '#333',
    margin: '5px 3px',
    cursor: 'pointer'
}

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('hu-HU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
};

function ShowMyBooking(props) {

    const { t } = useTranslation();

    const { contextData: { user, authKey }, isLoggedIn, activateCart, setCart, setDetails, setResponseId } = useContext(globalContext);
    const navigate = useNavigate();
    const routeParams = useParams();

    const [booking, setBooking] = useState(null);
    const cart = booking?.shoppingCart;
    useEffect(() => {
        if (!authKey) {
            navigate('/login');
        } else {

            if (isLoggedIn()) {
                axios.get(`/api/my-booking/customers/${user?.id}/orders/${routeParams?.orderId}`)
                    .then(res => {
                        if (res?.data) {
                            setBooking(res?.data);
                        }
                    }).catch(err => console.log(err))
            }

        }
    }, [user, authKey])

    const setBookingByBookingId = () => {
        axios.get(`/api/my-booking/customers/${user?.id}/orders/${routeParams?.orderId}`)
            .then(res => {
                if (res?.data) {
                    setBooking(res?.data);
                }
            }).catch(err => console.log(err))
    }


    const deleteBooking = () => {
        axios.patch(`/api/my-booking/customers/${user?.id}/orders/${booking?.id}`)
            .then(res => {
                navigate('/my-booking')
            }).catch(err => console.log(err))
        return;
    }

    const completePayment = () => {
        if (!booking?.shoppingCart) {
            console.error('Nincs kosár adat a booking-ban');
            return;
        }

        const cart = booking.shoppingCart;
        const search = cart.search;
        
        try {
            // Kosár adatok beállítása
            setCart(cart);

            // Form values beállítása a search alapján
            if (search) {
                const formValues = {
                    origin_airport: search.departure?.code || '',
                    destination_airport: search.arrival?.code || '',
                    departureSideStartDate: search.departureSideStartDate || '',
                    arrivalSideEndDate: search.arrivalSideEndDate || '',
                    arrivalSideStartDate: search.arrivalSideStartDate || '',
                    departureSideEndDate: search.departureSideEndDate || '',
                    numberOfAdults: search.numberOfAdults || '',
                    numberOfChildren: search.numberOfChildren || '',
                    numberOfInfants: search.numberOfInfants || '',
                    singleTrip: search.singleTrip || false
                };
                
                // Direktben localStorage és context beállítás
                window.localStorage.setItem('formValues', JSON.stringify(formValues));
                setResponseId(search.id);
            }

            // Felhasználó adatok beállítása
            if (cart.firstName || cart.lastName || cart.email) {
                const details = {
                    surname: cart.surname || '',
                    firstname: cart.firstName || '',
                    email: cart.email || '',
                    phone: cart.phone || '',
                    flightNumber: cart.directionFrom?.flightNumber || '',
                    flightArrival: cart.directionFrom?.flightArrival || '',
                    flightDeparture: cart.directionFrom?.flightDeparture || '',
                    flightNumber2: cart.directionTo?.flightNumber || '',
                    flightArrival2: cart.directionTo?.flightArrival || '',
                    flightDeparture2: cart.directionTo?.flightDeparture || '',
                    ffp: cart.ffpNumber || ''
                };
                setDetails(details, cart.id);
            }

            // Navigáció a kosár fizetési részhez (lépés 2)
            navigate('/cart?step=2');

        } catch (error) {
            console.error('Hiba a fizetés befejezése során:', error);
        }
    }

    return (
        <Box sx={{ py: 5, bgcolor: 'rgba(0,0,0, .2)' }}>
            <Container>
                <Paper sx={{ p: 3, bgcolor: '#fff', m: 3 }}>
                    <Typography sx={{ fontSize: '32px', fontWeight: 300, textAlign: 'center', pb: 2 }}>{t("ShowMyBooking.myBooking")}</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1"><strong>Booking Nr.:</strong> PLUS{String(booking?.id).padStart(8, '0')}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1"><strong>Status:</strong> {booking?.status}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.name")}</strong> {cart?.firstName} {cart?.surname}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.email")}</strong> {cart?.email}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.phone")}</strong> {cart?.phone}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.numberOfPassengers")}</strong> {(cart?.search?.numberOfAdults || 0) + (cart?.search?.numberOfChildren || 0) + (cart?.search?.numberOfInfants || 0)}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.totalAmount")}</strong> {booking?.totalAmountInEuro} EUR</Typography>
                        </Grid>
                        {cart?.search?.departure?.name && cart?.search?.arrival?.name && <Grid item xs={12}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.affectedAirports")}</strong> {cart?.search?.departure?.name} ({cart?.search?.departure?.code}) - {cart?.search?.arrival?.name} ({cart?.search?.arrival?.code})</Typography>
                        </Grid>}
                        {cart?.directionFrom?.flightNumber && <Grid item xs={12}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.outboundFlight")}</strong> {cart?.directionFrom?.flightNumber} ({formatDate(cart?.directionFrom?.flightDeparture)} - {formatDate(cart?.directionFrom?.flightArrival)})</Typography>
                        </Grid>}
                        {cart?.directionTo?.flightNumber && <Grid item xs={12}>
                            <Typography variant="body1"><strong>{t("ShowMyBooking.returnFlight")}</strong> {cart?.directionTo?.flightNumber} ({formatDate(cart?.directionTo?.flightDeparture)} - {formatDate(cart?.directionTo?.flightArrival)})</Typography>
                        </Grid>}
                        <Grid item sm={12}>
                            <Box sx={{ width: '100%', textAlign: 'center', pt: 5 }}>
                                {cart?.directionTo?.departureTransfer?.id && <>
                                    <TransferDetails
                                        setBookingByBookingId={setBookingByBookingId}
                                        transfer={cart?.directionTo?.departureTransfer}
                                        userId={user?.id}
                                        orderId={cart?.order?.id}
                                        type="arrivalSideDepartureTransferAddress"
                                    />
                                </>}
                                {cart?.directionTo?.arrivalTransfer?.id && <>
                                    <TransferDetails
                                        setBookingByBookingId={setBookingByBookingId}
                                        transfer={cart?.directionTo?.arrivalTransfer}
                                        userId={user?.id}
                                        orderId={cart?.order?.id}
                                        type="arrivalSideArrivalTransferAddress"
                                    />
                                </>}
                                {cart?.directionFrom?.departureTransfer?.id && <>
                                    <TransferDetails
                                        setBookingByBookingId={setBookingByBookingId}
                                        transfer={cart?.directionFrom?.departureTransfer}
                                        userId={user?.id}
                                        orderId={cart?.order?.id}
                                        type="departureSideDepartureTransferAddress"
                                    />
                                </>}
                                {cart?.directionFrom?.arrivalTransfer?.id && <>
                                    <TransferDetails
                                        setBookingByBookingId={setBookingByBookingId}
                                        transfer={cart?.directionFrom?.arrivalTransfer}
                                        userId={user?.id}
                                        orderId={cart?.order?.id}
                                        type="departureSideArrivalTransferAddress"
                                    />
                                </>}

                                {cart?.directionTo?.departureLounge?.id && <>
                                    <LoungeDetails lounge={cart?.directionTo?.departureLounge} />
                                </>}
                                {cart?.directionFrom?.departureLounge?.id && <>
                                    <LoungeDetails lounge={cart?.directionFrom?.departureLounge} />
                                </>}

                                {cart?.directionTo?.departureParking?.id && <>
                                    <ParkingDetails parking={cart?.directionTo?.departureParking} />
                                </>}
                                {cart?.directionFrom?.departureParking?.id && <>
                                    <ParkingDetails parking={cart?.directionFrom?.departureParking} />
                                </>}

                            </Box>
                        </Grid>
                        <Grid item sm={12}>
                            <Box sx={{ width: '100%', textAlign: 'center', pt: 5 }}>
                                {booking?.status === 'COMPLETED' && <>
                                    <strong style={{ paddingBottom: '10px', display: 'inline-block' }}>{t("ShowMyBooking.downloadTickets")}</strong>
                                    <br />
                                    {cart?.directionTo?.departureTransfer?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/transfers/${cart?.directionTo?.departureTransfer?.id}/download-ticket`}>{t("ShowMyBooking.transfer")}</Button></>}
                                    {cart?.directionTo?.arrivalTransfer?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/transfers/${cart?.directionTo?.arrivalTransfer?.id}/download-ticket`}>{t("ShowMyBooking.transfer")}</Button></>}
                                    {cart?.directionFrom?.departureTransfer?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/transfers/${cart?.directionFrom?.departureTransfer?.id}/download-ticket`}>{t("ShowMyBooking.transfer")}</Button></>}
                                    {cart?.directionFrom?.arrivalTransfer?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/transfers/${cart?.directionFrom?.arrivalTransfer?.id}/download-ticket`}>{t("ShowMyBooking.transfer")}</Button></>}

                                    {cart?.directionTo?.departureLounge?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/lounges/${cart?.directionTo?.departureLounge?.id}/download-ticket`}>{t("ShowMyBooking.lounge")}</Button></>}
                                    {cart?.directionFrom?.departureLounge?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/lounges/${cart?.directionFrom?.departureLounge?.id}/download-ticket`}>{t("ShowMyBooking.lounge")}</Button></>}

                                    {cart?.directionTo?.departureParking?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/parkings/${cart?.directionTo?.departureParking?.id}/download-ticket`}>{t("ShowMyBooking.parking")}</Button></>}
                                    {cart?.directionFrom?.departureParking?.id && <><Button variant="outlined" href={`/api/custom/contents/shopping-carts/${cart?.id}/parkings/${cart?.directionFrom?.departureParking?.id}/download-ticket`}>{t("ShowMyBooking.parking")}</Button></>}
                                </>}
                            </Box>
                        </Grid>
                        <Grid item sm={12}>
                            <Box sx={{ width: '100%', textAlign: 'center', pt: 5 }}>
                                <strong style={{ paddingBottom: '10px', display: 'inline-block' }}>{t("ShowMyBooking.activities")}</strong>
                                <br />
                                {booking?.status === 'PENDING_PAYMENT' && (
                                    <>
                                        <Button 
                                            color="success" 
                                            variant="contained" 
                                            onClick={completePayment}
                                            sx={{ mr: 2, mb: 2 }}
                                        >
                                            {t("ShowMyBooking.completePayment")}
                                        </Button>
                                        <br />
                                    </>
                                )}
                                <Button color="error" onClick={() => deleteBooking()} variant="outlined">{t("ShowMyBooking.deleteBooking")}</Button>

                            </Box>
                        </Grid>
                    </Grid>

                </Paper>
            </Container>

        </Box>


    );
}

export default ShowMyBooking;
